import { render, staticRenderFns } from "./ThaiPhoneNumber.vue?vue&type=template&id=05cdfb05&scoped=true&"
import script from "./ThaiPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./ThaiPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cdfb05",
  null
  
)

export default component.exports